import type { SuggestionData } from './create-suggestion-data.js';
import { createSuggestionData } from './create-suggestion-data.js';
import type { ListAutocompletionConfig } from './list-autocompletion-types.js';
import { AutocompleteProvider } from '../autocompletion.extension.js';

/** Returns suggestions function for list autocompletion */
export function listAutocompletion(
  listAutoCompletionConfig: ListAutocompletionConfig,
): AutocompleteProvider {
  let suggestionData: SuggestionData | undefined;

  return async (context) => {
    if (
      suggestionData === undefined ||
      typeof listAutoCompletionConfig.autocompletionList === 'function'
    ) {
      suggestionData = await createSuggestionData(listAutoCompletionConfig);
    }

    if (suggestionData === undefined) {
      return {
        from: context.pos,
        suggestions: [],
      };
    }

    const before = context.state.doc.slice(0, context.pos).toString();

    const found = before.search(suggestionData.prefixRegex);
    const match =
      found < 0
        ? null
        : { from: found, to: context.pos, text: before.slice(found) };

    if (match) {
      const pos = match.text.search(suggestionData.suggestionRegex);

      return {
        from: pos < 0 ? match.to : match.from + pos,
        suggestions: suggestionData.suggestions,
        validFor: suggestionData.suggestionRegex,
        reopen: !!listAutoCompletionConfig.reopen,
      };
    }

    return {
      from: context.pos,
      suggestions: [],
    };
  };
}
